import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, ActivatedRouteSnapshot, Route, Router, CanActivateChild } from '@angular/router';
import { ConfigService } from '../Services/ConfigService';

@Injectable()
export class PaidAuthGuard implements CanActivate, CanLoad, CanActivateChild {

	constructor(public configData: ConfigService, private router: Router) { }

	canLoad(route: Route): boolean {
		return this.checkAccess();
	}

	canActivateChild(route: ActivatedRouteSnapshot): boolean {
		return this.canActivate(route);
	}

	canActivate(route: ActivatedRouteSnapshot): boolean {
		return this.checkAccess();
	}

	checkAccess(): boolean {
		if (this.configData.AppConfig.me != "" && this.configData.isPaid) {
			return true;
		} else {
			this.router.navigate(['ang/Payment']);
			return false;
		}
	}
}